import { useState } from "react"

export default function usePasswordToggle() {
  const [visible, setVisible] = useState(false)
  const toggle = () => setVisible((v) => !v)
  const inputType = visible ? "text" : "password"
  return [inputType, visible, toggle]
}
